import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import {GetAppOutlined} from '@material-ui/icons';
import LabelValue from '../../../shared/labelvalue/LabelValue.js';
import ContainedButton from '../../../shared/buttons/ContainedButton.tsx';
import TextButton from '../../../shared/buttons/TextButton.tsx';
import TabelaProcessosSeletivos from '../../components/inscricao/TabelaProcessosSeletivos.jsx';
import useDownloadSegundoPlano from '../../../shared/downloadsegundoplano/useDownloadSegundoPlano.js';
import {URL_INSCRICOES_ARQUIVOS_PLANILHA} from '../../../../constants/index.js';

const CORPO = {};
// Só o programa 1 tem ENEM junto do processo seletivo, então só ele pergunta se separa as abas.
const ID_PROGRAMA_COM_ENEM = 1;

const useStyles = makeStyles(() => ({
    root: {
        width: 800,
        maxWidth: '100%'
    },
    contentRoot: {overflowY: 'initial'}
}));

/* Planilha de inscritos de um processo de seleção (módulo CFGERPLINS). */
export default function DialogPlanilhaInscritos(props) {
    const {open, onClose} = props;
    const classes = useStyles();
    const {iniciar} = useDownloadSegundoPlano();
    const [processo, setProcesso] = useState(null);
    const [separarAbas, setSepararAbas] = useState('false');

    // Cada abertura começa sem processo escolhido e com as abas juntas.
    useEffect(() => {
        if (open) {
            setProcesso(null);
            setSepararAbas('false');
        }
    }, [open]);

    const exibirSepararAbas = !!processo && !!processo.programa && processo.programa.id === ID_PROGRAMA_COM_ENEM;

    const handleGerar = () => {
        if (!open || !processo) {
            return;
        }
        const separar = exibirSepararAbas && separarAbas === 'true';

        // A planilha é gerada em segundo plano: o diálogo fecha e o andamento fica no canto inferior direito.
        iniciar({
            url: `${URL_INSCRICOES_ARQUIVOS_PLANILHA(processo.id)}?separarAbas=${separar}`,
            data: CORPO,
            nomeArquivo: processo.descricao ? `${processo.descricao}.xls` : 'planilha-inscritos.xls',
            titulo: 'Planilha de Inscritos',
            descricao: processo.descricao
        });
        onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth={false}
            classes={{paper: classes.root}}
            scroll='body'
            aria-labelledby='dialog-planilha-inscritos-titulo'>
            <DialogTitle id='dialog-planilha-inscritos-titulo'>Planilha de Inscritos</DialogTitle>
            <DialogContent classes={{root: classes.contentRoot}}>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <TabelaProcessosSeletivos onSelecionar={setProcesso}/>
                    </Grid>
                    {exibirSepararAbas && (
                        <Grid item xs={12}>
                            <LabelValue label='Separar abas Processo Seletivo e ENEM?'>
                                <FormControl component='fieldset'>
                                    <RadioGroup
                                        row
                                        aria-label='Separar abas Processo Seletivo e ENEM'
                                        value={separarAbas}
                                        onChange={event => setSepararAbas(event.target.value)}>
                                        <FormControlLabel value='true' control={<Radio color='primary'/>} label='Sim'/>
                                        <FormControlLabel value='false' control={<Radio color='primary'/>} label='Não'/>
                                    </RadioGroup>
                                </FormControl>
                            </LabelValue>
                        </Grid>
                    )}
                </Grid>
            </DialogContent>
            <DialogActions>
                <TextButton onClick={onClose}>Fechar</TextButton>
                <ContainedButton
                    startIcon={<GetAppOutlined/>}
                    disabled={!processo}
                    onClick={handleGerar}>
                    Gerar Planilha
                </ContainedButton>
            </DialogActions>
        </Dialog>
    );
}

DialogPlanilhaInscritos.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
};
